<div class="d-flex justify-content-between pb-4 align-items-sm-center align-items-start gap-space-12 flex-sm-row flex-column">
    @if (slotSelected) {
        <p class="typography-label-large" i18n="@@CommonTimegridDurationXMinutes">Duration: {{slotSelected.Duration}} minutes</p>
    } @else {
        <!-- empty div to keep the justify content between layout -->
        <div></div>
    }
    <div class="d-flex gap-space-12 align-items-center flex-wrap">
        @if (uniqueLocations.length) {
            <lib-chip-button-select [panelWidth]="270" (selectionChange)="LocationChange($event!)">
                <ng-template #triggerTemplate let-item>
                    <ng-container *ngTemplateOutlet="locationStatusLabel; context:{$implicit:currentLocationSelected}"></ng-container>
                </ng-template>
                <ng-container *ngFor="let item of uniqueLocations">
                    <lib-chip-button-select-item [value]="item.ID">
                        <ng-container *ngTemplateOutlet="locationStatusLabel; context:{$implicit:item}"></ng-container>
                    </lib-chip-button-select-item>
                </ng-container>
            </lib-chip-button-select>
        }
        <lib-chip-time-range-picker
            class="d-flex"
            [labels]="chipTimeFilterLabels"
            (selectionChange)="TimeRangeChange($event)">
        </lib-chip-time-range-picker>
    </div>
</div>
@if (filteredSlots.length) {
    <div [ngClass]="{ 'sb-time-grid-picker-desktop': !isMobile, 'sb-time-grid-picker-mobile': isMobile }">
        @for (slot of filteredSlots; track slot.EventID) {
            <lib-button
                [kind]="ButtonKind.Secondary"
                [active]="slot.StartDate == slotSelected!.StartDate"
                [size]="ButtonSize.Large"
                [stretch]="true"
                (click)="TimeChangeEvent(slot)">
                <ng-container label>{{slot.StartDate | formatTime: 'short'}}</ng-container>
            </lib-button>
        }
    </div>
} @else {
    <div class="padding-x-24 padding-y-32">
        <lib-empty-state
            [emptyStateGraphic]="EmptyStateGraphic.NoResultsFound">
            <ng-container emptyStateText i18n="@@Common_TimegridPicker_EmptyState_Title">No #lessons# match your filters</ng-container>
            <ng-container emptyStateDescription i18n="@@Common_TimegridPicker_EmptyState_Description">
                We couldn't find any #lessons# that match your filters. Try adjusting or resetting them to see more options
            </ng-container>
        </lib-empty-state>
    </div>
}

<ng-template #locationStatusLabel let-item>
    <lib-status-label [kind]="StatusKind.Custom"
        [icon]="item.Icon | calendarEventLocationIcon" [labelColor]="item.Color | method: BackgroundColorClass">
        <ng-container label>
            {{item.Name}}
        </ng-container>
    </lib-status-label>
</ng-template>
